import { PostHogFeature } from "posthog-js/react";
import { forwardRef, useEffect, useState } from "react";
import { QuestionMarkCircleLinear } from "../../../Iconsax/QuestionMarkCircleLinear.js";
import { useSidebar } from "../../Sidebar.context.js";
import { SidebarItemCore } from "./components/SidebarItemCore/SidebarItemCore.component.js";
import { SidebarItemCoreProps } from "./components/SidebarItemCore/SidebarItemCore.types.js";
import { SidebarItemSubMenu } from "./components/SidebarItemSubMenu/SidebarItem.component.js";
import { SidebarItemProps, SidebarItemSubMenuItemDefinition } from "./SidebarItem.types.js";

export const SidebarItem = forwardRef<HTMLDivElement, SidebarItemProps>(
    (
        {
            id,
            label,
            icon = QuestionMarkCircleLinear,
            animatedIcon,
            subMenu,
            onClick,
            disabled,
            badge,
            rightComponent,
            extraClassName = "",
            experiment,
            ...attributes
        },
        ref,
    ): JSX.Element => {
        const { selected } = useSidebar();
        const [isOpen, setIsOpen] = useState<boolean>(subMenu?.isOpen ?? false);

        const handleSubMenuClick: SidebarItemSubMenuItemDefinition["onClick"] = (subMenuDefinition, event) => {
            subMenuDefinition.onClick(subMenuDefinition, event);
        };

        useEffect(() => {
            if (subMenu === undefined || subMenu.isOpen === undefined) return;

            if (subMenu.isOpen !== isOpen) {
                setIsOpen(subMenu.isOpen);
            }
        }, [subMenu?.isOpen]);

        const coreProps: SidebarItemCoreProps = {
            id,
            label,
            icon,
            animatedIcon,
            subMenu,
            onClick,
            disabled,
            badge,
            rightComponent,
            isOpen,
            onToggleOpen: () => setIsOpen((v) => !v),
        };

        return (
            <div {...attributes} className={extraClassName} ref={ref} id={id}>
                {experiment ? (
                    <PostHogFeature flag={experiment.experimentName} match={experiment.match}>
                        <SidebarItemCore {...coreProps} />
                    </PostHogFeature>
                ) : (
                    <SidebarItemCore {...coreProps} />
                )}

                <SidebarItemSubMenu selectedKey={selected} onClick={handleSubMenuClick} subMenu={subMenu ? { ...subMenu, isOpen } : subMenu} />
            </div>
        );
    },
);
